import React from 'react';
import { motion } from 'framer-motion';
import { Hand, Grip, ShieldAlert } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
export function TriGripSystem() {
  const pillars = [{
    icon: <Hand className="w-12 h-12 text-neon-cyan" data-id="element-203" />,
    title: 'CRUSH',
    subtitle: '(FUERZA)',
    desc: 'La capacidad de cerrar la mano con máxima potencia. Fundamental para deadlifts, remos y control total.'
  }, {
    icon: <Grip className="w-12 h-12 text-neon-cyan" data-id="element-204" />,
    title: 'PINCH',
    subtitle: '(CONTROL)',
    desc: 'Fuerza de los dedos y el pulgar. El secreto olvidado para un agarre inquebrantable y estabilización.'
  }, {
    icon: <ShieldAlert className="w-12 h-12 text-neon-cyan" data-id="element-205" />,
    title: 'SUPPORT',
    subtitle: '(RESISTENCIA)',
    desc: 'Soportar cargas pesadas por tiempo prolongado. Adiós a las manos que se abren antes de terminar la serie.'
  }];
  return <section className="py-24 bg-dark-800 relative border-y border-dark-700" data-id="element-206">
      <div className="container mx-auto px-4" data-id="element-207">
        <SectionHeading title="SISTEMA TRIGRIP" subtitle="No es un entrenamiento más. Es un sistema biomecánico diseñado para no fallar." data-id="element-208" />

        <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto mt-16" data-id="element-209">
          {pillars.map((pillar, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2
        }} className="bg-dark-900 border border-dark-700 p-8 rounded-xl relative overflow-hidden group hover:border-neon-cyan/50 transition-all duration-500" data-id="element-210">
              <div className="absolute top-0 right-0 w-32 h-32 bg-neon-cyan/5 rounded-bl-full -mr-16 -mt-16 transition-transform group-hover:scale-150 duration-700" data-id="element-211"></div>

              <div className="mb-8 relative z-10" data-id="element-212">
                <div className="w-20 h-20 bg-dark-800 rounded-2xl flex items-center justify-center border border-dark-700 group-hover:border-neon-cyan/30 group-hover:shadow-neon-cyan transition-all duration-300" data-id="element-213">
                  {pillar.icon}
                </div>
              </div>

              <h3 className="text-3xl font-oswald font-bold text-white mb-1 relative z-10" data-id="element-214">
                {pillar.title}
              </h3>
              <span className="text-neon-cyan font-oswald tracking-widest text-sm mb-4 block relative z-10" data-id="element-215">
                {pillar.subtitle}
              </span>

              <p className="text-gray-400 font-inter relative z-10" data-id="element-216">
                {pillar.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}